module.exports = __webpack_public_path__ + "static/media/studiofoto-WB_roadbike.06f30fda.jpg";